import { useAppDispatch } from '@/store/hooks'
import { setAuth } from '@/store/slices/authSlice'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import { useEffect } from 'react'

export const useAuthListener = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const auth = getAuth()
    return onAuthStateChanged(auth, async user => {
      if (user) {
        const idTokenResult = await user.getIdTokenResult()
        const roles = idTokenResult.claims.roles ? (idTokenResult.claims.roles as string[]) : []
        dispatch(setAuth({ user: { uid: user.uid, email: user.email, roles } }))
      } else {
        dispatch(setAuth({ user: null }))
      }
    })
  }, [dispatch])
}
